import React, {useCallback} from "react";
import {Box, Typography} from "@mui/material";
import DebouncedTextField from "../../../components/DebouncedTextField";
import {useRegulationsData} from "../contexts/RegulationsProvider";
import {isEmpty, map, findWhere} from "underscore";

const RecordsCountInput = () => {
  const {currentFilters, setCurrentFilters} = useRegulationsData();

  const setRecordCount = useCallback(
    (jurisdictionName, value) => {
      setCurrentFilters((prev) => {
        const newRecords = [...prev.records];
        const target = findWhere(newRecords, {value: jurisdictionName});
        target.count = isEmpty(value) ? 0 : parseInt(value, 10);
        return {...prev, records: newRecords};
      });
    },
    [setCurrentFilters],
  );

  if (isEmpty(currentFilters.records)) {
    return <div>No Jurisdiction(s) Selected</div>;
  }
  return (
    <Box>
      <Typography># of records impacted by jurisdiction</Typography>
      <Box pt={2} display="flex" flexDirection="column" gap={2}>
        {map(currentFilters.records, (record) => (
          <DebouncedTextField
            key={record.value}
            id={`records-${record.value}`}
            label={record.value}
            variant="outlined"
            value={record.count}
            type="number"
            onChange={(val) => setRecordCount(record.value, val)}
            InputProps={{inputProps: {min: 0}}}
          />
        ))}
      </Box>
    </Box>
  );
};

export default RecordsCountInput;
